import Vue from "vue";
import { Component, Emit, Prop } from "vue-property-decorator";
import Organigram from "../organigram/organigram.controller";

@Component({
    name: 'organigramModal',
    components: {
        Organigram: require('../organigram/organigram.vue.html').default
    }
})
export default class OrganigramModal extends Vue {
    @Prop({ required: true })
    modalId!: string;

    reloadAll(): Promise<void> {
        return (this.$refs.organigram as Organigram).reloadAll();
    }

    private forceClose(): void {
        eval('$("#' + this.modalId + '").modal("hide")');
        this.close();
    }

    @Emit('close')
    private close(): void {

    }
}